export const experience = [
  {
    company: "Zenthom",
    role: "Software Engineer",
    dates: "Mar 2026 – Present",
    description:
      "Independently developed a React and TypeScript frontend across HQ, facility manager, and customer portals. Built reusable architecture and integrated supported API workflows.",
  },
  {
    company: "Cartier Creative",
    role: "Next.js Frontend Developer · Contract",
    dates: "Jul 2025 – Oct 2025",
    description:
      "Built Driwego’s B2C and B2B storefront interfaces and vendor panel features with Next.js, Medusa.js, and modern data and form tooling.",
  },
  {
    company: "Insightful3D",
    role: "Frontend Developer",
    dates: "Feb 2025 – Jul 2025",
    description:
      "Led Hutstack frontend development across property, tenancy, lease, maintenance, and financial management interfaces.",
  },
  {
    company: "Wazobia Technologies",
    role: "Software Developer",
    dates: "Nov 2021 – Sep 2024",
    description:
      "Developed a core website template engine, reusable templates, and rendering and customization workflows for a no-code website builder.",
  },
];
